class SkincareElement extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const optionsContainer = this.querySelector(".skincare__options");
    const detailSections = this.querySelectorAll(".skincare__detail");

    // 1. Logic for clicking an option to show details
    this.querySelectorAll(".skincare__option-wrapper").forEach((option) => {
      option.addEventListener("click", () => {
        const optionId = option.getAttribute("data-option-id");
        optionsContainer.style.display = "none";
        this.querySelector(`[data-detail-id="${optionId}"]`).style.display = "flex";
      });
    });

    // 2. Logic for "Choose Again" link to go back to options
    this.querySelectorAll(".skincare__detail-link").forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        // Hide all detail sections
        detailSections.forEach((detail) => {
          detail.style.display = "none";
        });
        // Show the options grid again
        optionsContainer.style.display = "flex";
        
        // Optional: Scroll to top of section for better UX
        this.scrollIntoView({ behavior: 'smooth' });
      });
    });
  }
}

customElements.define("skincare-element", SkincareElement);